import * as React from 'react';
import TextInput from '@packages/systems/design-system/TextInput';
import {Label} from './LinkUIComponents';
import {dissoc} from '@packages/utilities/key-map';
import type {State} from './LinkTypes';

export const useEmail = (state: State, dispatch: (arg1?: any) => void) => {
  const [email = '', setEmail] = React.useState(state.email);
  const [subject = '', setSubject] = React.useState(state.subject);

  const onChangeEmail = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setEmail(e.currentTarget.value);

  const onChangeSubject = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setSubject(e.currentTarget.value);

  const onBlurEmail = React.useCallback(() => {
    let newState = {...state, email};

    // Remove `email` from data when empty ''
    if (email === '') {
      // @ts-expect-error - TS2739 - Type '{ [key: string]: any; }' is missing the following properties from type '{ email: string; mode: Mode; url?: string | undefined; pageId?: string | undefined; domId?: string | undefined; subject?: string | undefined; tel?: string | undefined; assetId?: string | undefined; target?: "_self" | ... 1 more ... | undefined; preload?: "none" | ... 2 more ... | undefined; }': email, mode
      newState = dissoc('email')(newState);
    }

    dispatch({
      payload: newState,
      meta: {analytics: {type: 'element-settings-updated', value: 'email'}},
    });
  }, [dispatch, state, email]);

  const onBlurSubject = React.useCallback(() => {
    let newState = {...state, subject};

    // Remove `subject` from data when empty ''
    if (subject === '') {
      // @ts-expect-error - TS2739 - Type '{ [key: string]: any; }' is missing the following properties from type '{ subject: string; mode: Mode; url?: string | undefined; pageId?: string | undefined; domId?: string | undefined; email?: string | undefined; tel?: string | undefined; assetId?: string | undefined; target?: "_self" | ... 1 more ... | undefined; preload?: "none" | ... 2 more ... | undefined; }': subject, mode
      newState = dissoc('subject')(newState);
    }

    dispatch({
      payload: newState,
      meta: {
        analytics: {type: 'element-settings-updated', value: 'email subject'},
      },
    });
  }, [dispatch, state, subject]);

  React.useEffect(() => setEmail(state.email), [state.email]);
  React.useEffect(() => setSubject(state.subject), [state.subject]);

  return {
    email,
    subject,
    onBlurEmail,
    onBlurSubject,
    onChangeEmail,
    onChangeSubject,
  };
};

export const LinkEmailMode = ({
  state,
  dispatch,
  isOverride,
  hasLegacyDynamoHrefBinding,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
  hasLegacyDynamoHrefBinding?: boolean;
}) => {
  const {
    email,
    subject,
    onBlurEmail,
    onBlurSubject,
    onChangeEmail,
    onChangeSubject,
  } = useEmail(state, dispatch);

  return (
    <>
      {/* Email */}
      {hasLegacyDynamoHrefBinding ? null : (
        <>
          <Label
            data-automation-id="symbols-dataType-contentType"
            isOverride={isOverride}
          >
            Email
          </Label>
          <TextInput
            data-automation-id="Type--Plugin_Text_Email"
            onBlur={onBlurEmail}
            onChange={onChangeEmail}
            placeholder="e.g. bob@gmail.com"
            type="text"
            value={email}
          />
        </>
      )}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Subject
      </Label>
      <TextInput
        data-automation-id="Type--Plugin_Text_Subject"
        onBlur={onBlurSubject}
        onChange={onChangeSubject}
        placeholder="e.g. You‘ve got mail!"
        type="text"
        value={subject}
      />
    </>
  );
};
